import './utils/logger';
import sdkInfo from './sdk-info';
import { collectJsError } from './collect/jserror-collect';
import eventMessage from './components/event-message';
import { setupRequsetProxy } from './http';
import loadscript from './utils/loadscript';
import HB_STATUS from './constant/hb-status';
import EVENT_MSG_TYPE from './constant/event-msg-type';
// import xhrRequest from './utils/xhr-request';
import { pathJoin } from './utils/url';
import getConfFromScript from './utils/get-conf-from-script';
import { BIZOP_TYPE, DEFAULT_APPID, DEFAULT_SERVER_PATH, DEFAULT_TID, SERVER_CONFIG_API } from './constant';
import safeInvoke from './utils/safe-invoke';
import { win } from './global';
import getServerConfig from './utils/get-server-config';
import formatReportPath from './utils/format-report-path';
import ymcHeaderDecode from './utils/ymc-header-decode';
import userActionCollect from 'src/collect/user-action-collect';
import session from './components/session';
import { isWorkbench, setTimeoutIdle } from './utils';
import webVitals from 'src/components/web-vitals';
import Pipeline from './core/pipeline';
import performanceCollect from 'src/collect/performances';
import { ServicePageLCP } from './components/lcp';
import { getBizData, getUserInfo } from './workbench-custom';

const SYNC_TGAP_TIME = 10 * 60 * 1000;
let lcpMonitor = new ServicePageLCP();
let lastClickTime = 0;
// js资源所在位置
let RES_PATH = '';
let YMC_HOST = '';
let reportApiPath = ''; // 上报服务地址前缀
let ubaStatus = HB_STATUS.SETUP;
let onpremise = false;
const cacheBipOps = []; // 自定义业务操作实例的缓存列表
/**
 * 哈勃监控主体对象
 */
class HubbleMonitor {
  // status: HB_STATUS;
  gapTime: number;
  config: HBConfig;
  setupStartTime: number;
  reportDataListener: (messages: any[]) => void;
  constructor() {
    const conf = getConfFromScript();
    onpremise = conf.onpremise === '1' || win._IUAPPREMISESFLAG || /\d{3}$/.test(sdkInfo.v);
    RES_PATH = conf.jsPath;
    // this.status = HB_STATUS.SETUP;
    this.config = {
      autoCollect: conf.autoCollect !== '0',
      tid: conf.tid,
      appid: conf.appid,
      attrs: {},
    };
    if (conf.reportHost) {
      YMC_HOST = conf.reportHost;
    } else if(!onpremise) {
      YMC_HOST = conf.ymcEnv === 'test' ? 'ymc.yyuap.com' : 'ymc.yonyoucloud.com';
    }

    this.init();
    // 支持录制组件逻辑
    // try {
    //   if (onpremise && String(conf.bpr) === '1' && conf.reportPath) {
    //     const reportPath = new URL(formatReportPath(conf.reportPath));
    //     win.YMC_BPR_HOST = reportPath.origin;
    //   }
    // } catch (error) {
    //   hbLogger.debug(error);
    // }
  }
  set status(statu: HB_STATUS) {
    if (statu === HB_STATUS.DISABLED) {
      hbLogger.warn('UBA配置未开启');
    }
    ubaStatus = statu;
  }
  get status() {
    return ubaStatus;
  }
  get startTime() {
    return sdkInfo.startTime;
  }
  get reportUrl() {
    return formatReportPath(reportApiPath);
  }
  init () {
    collectJsError(); // 监听收集JS错误
    setupRequsetProxy(); // 安装异步请求代理
    userActionCollect(); // 开始收集用户行为
    webVitals(); // 收集Web Vitals指标
    performanceCollect(); // 性能相关数据收集

    performance.setResourceTimingBufferSize(500);
    const delaySetup = () => {
      // 页面加载完成后1s开始装载UBA核心逻辑
      setTimeout(() => this.setup(), 1000);
    };
    if(document.readyState === 'complete') {
      this.setupStartTime = Date.now();
      delaySetup();
    } else {
      safeInvoke(win, win.addEventListener, 'load', () => {
        this.setupStartTime = Date.now();
        delaySetup();
      });
    }
    hbLogger.debug('YMC UBA is ready. Waiting for installation enabled.');
    this.status = HB_STATUS.WAIT_RUNNING;
  }
  initLCPMonitor() {
    ['click', 'keydown', 'touchstart'].forEach(type => {
      safeInvoke(win, win.addEventListener, type, (ev) => {
        lcpMonitor.stopMonitoring();
        if (type === 'click') {
          lastClickTime = performance.now();
        }
      }, true);
    });
  }
  async setup() {
    if (!this.config.tid) {
      hbLogger.info(`未配置tid, 默认tid: ${DEFAULT_TID}`);
      this.config.appid = DEFAULT_TID;
    }
    if (!this.config.appid) {
      hbLogger.info(`未配置appid, 默认appid: ${DEFAULT_APPID}`);
      this.config.appid = DEFAULT_APPID;
    }

    const timeRet = await this.syncGapTime();
    if (!timeRet.openUba) {
      this.status = HB_STATUS.DISABLED;
      hbLogger.info(`UBA is DISABLED.`, sdkInfo.v);
    } else {
      this.status = HB_STATUS.RUNNING;
      hbLogger.info(`UBA is RUNNING.`, sdkInfo.v);
    }
    reportApiPath = timeRet.ymcApi || '';
    const pipeline = new Pipeline();
    eventMessage.setHandler((events) => {
      pipeline.eventHandler(events);
    });
    this.initLCPMonitor();
    this.autoSyncGapTime();
    this.loadExt();
  }
  autoSyncGapTime() {
    let syncTimer = false;
    let isFirst = true;
    const handle = () => {
      if (isFirst) {
        isFirst = false;
        hbLogger.debug('autoSyncGapTime first!');
      } else if (!syncTimer) {
        syncTimer = true;
        setTimeoutIdle(() => {
          this.syncGapTime().then(() => {
            if (this.status === HB_STATUS.DISABLED) {
              ['click', 'touchend'].forEach(type => {
                safeInvoke(win, win.removeEventListener, type, handle, true);
              });
              hbLogger.debug('autoSyncGapTime remove!');
            }
          });
          setTimeout(() => {
            syncTimer = false;
          }, SYNC_TGAP_TIME);
        });
      }
    };
    ['click', 'touchend'].forEach(type => {
      safeInvoke(win, win.addEventListener, type, handle, true);
    });
  }
  loadExt () {
    if (location.href.includes('ubaExtendedMonitor') && RES_PATH) {
      loadscript(pathJoin(RES_PATH, `uba-extMonitor.js?v=${sdkInfo.v}`));
    }
  }
  // async loadCore() {
  //   // 请求获取服务配置
  //   this.syncGapTime().then((ret) => {
  //     if (!ret.openUba) {
  //       this.status = HB_STATUS.DISABLED;
  //     }
  //     if (RES_PATH) {
  //       loadscript(pathJoin(RES_PATH, `uba-core.js?v=${sdkInfo.v}`), () => {
  //         if (this.status === HB_STATUS.WAIT_RUNNING) {
  //           this.status = HB_STATUS.RUNNING;
  //         }
  //         hbLogger.info(`Hubble UBA is ${this.status === HB_STATUS.RUNNING ? 'RUNNING' : 'DISABLED'}.`, sdkInfo.v);
  //         if (this.status === HB_STATUS.RUNNING) {
  //           this.autoSyncGapTime();
  //         }
  //       });
  //       // xhrRequest(pathJoin(RES_PATH, `2.x.version?_t=${Date.now()}`)).catch(() => sdkInfo.v).then((ver: string) => {
  //       //   let version = String(ver);
  //       //   const mats = version.match(/^(\d+)\.\d+\.\d+/);
  //       //   if(!mats) {
  //       //     version = sdkInfo.v;
  //       //   }
  //       //   hbLogger.debug(`Loading and installing. index version: ${sdkInfo.v}, core version: ${version}`);
  //       //   //
  //       // });
  //     } else {
  //       hbLogger.warn('uba资源路径获取失败');
  //     }
  //   });
  // }
  syncGapTime() {
    let configApi = SERVER_CONFIG_API;
    if (!/^http/.test(win.location.href)) {
      if (YMC_HOST) {
        configApi = 'https://' + YMC_HOST + SERVER_CONFIG_API;
      } else {
        hbLogger.error('Failed to obtain the reporting HOST.');
        return Promise.resolve({ time: 0, openUba: false, ymcApi: '' });
      }
    }
    return getServerConfig(configApi).then((ret) => {
      this.gapTime = ret.time > 0 ? ret.time - Date.now() : -1;
      // hbLogger.debug('syncGapTime!', this.gapTime);
      if (!ret.openUba && this.status === HB_STATUS.RUNNING){
        this.status = HB_STATUS.DISABLED;
      }
      if (!/^http/.test(win.location.href) && /^\//.test(ret.ymcApi)) {
        ret.ymcApi = 'https://' + YMC_HOST + ret.ymcApi;
      }
      return ret;
    });
  }
  startBizOp(ba: string, option?: any): { end: () => void } {
    const { btype = BIZOP_TYPE.SINGLE_POINT, timeout = 60000 } = (() => {
      if (typeof option === 'number') {
        return { timeout: option };
      }
      return option || {};
    })();
    // 单点效率场景，不开启则直接返回空操作
    if (btype === BIZOP_TYPE.SINGLE_POINT && !location.href.includes('singlePointTiming')) {
      return { end: () => void 0 };
    }
    const startTime = Date.now();
    const curTimeoutVal = Math.min(Math.max(timeout, 1000), 5 * 60 * 1000);
    let finish: (value?: any) => void;
    const endBizOp = new Promise((resolve) => {
      finish = resolve;
      setTimeout(() => resolve(0), curTimeoutVal);
    }).then(ret => {
      // 从缓存中移除对应ba的所有业务操作
      for (let i = cacheBipOps.length - 1; i >= 0; i--) {
        if (cacheBipOps[i].ba === ba) {
          cacheBipOps.splice(i, 1);
        }
      }
      return ret;
    });
    eventMessage.publish({
      time: startTime,
      type: EVENT_MSG_TYPE.BIZOP,
      data: { ba, endBizOp, timeout: curTimeoutVal, btype },
    });
    const result = { ba, startTime, end: () => finish(Date.now()) };
    cacheBipOps.push(result);
    return result;
  }
  endBizOp(ba?: string) {
    cacheBipOps.forEach(bipOp => {
      if (ba) {
        if (bipOp.ba === ba) {
          bipOp.end();
        }
      } else {
        bipOp.end();
      }
    });
  }
  report(eventName: string, attrsData: Record<string, unknown>) {
    if(/^HB/.test(eventName)) {
      throw new Error('内置占用，不支持以HB开头命名事件!');
    }
    // 工作台单页页签模式兼容，新开页签时启动LCP监控，并关联最近一次点击时间
    if (eventName === 'WBPagetab' && attrsData?.type === 'open' && performance.now() - lastClickTime < 1000) {
      lcpMonitor.startMonitoring(lastClickTime);
    }
    eventMessage.publish({
      time: Date.now(),
      type: EVENT_MSG_TYPE.CUSTOM,
      isManual: true,
      data: {
        en: eventName,
        attrs: attrsData,
      },
    });
  }
  reportCountEvent(ecid: string, ecbiz?: string) {
    if(ecid) {
      eventMessage.publish({
        time: Date.now(),
        type: EVENT_MSG_TYPE.COUNT,
        isManual: true,
        data: { ecid, ecbiz },
      });
    } else {
      hbLogger.warn('reportCountEvent ecid is required!');
    }
  }
  // 支持BPR录制获取前端数据使用
  addReportDataListener(listener: (messages: any[]) => void) {
    this.reportDataListener = listener;
  }
  removeReportDataListener() {
    this.reportDataListener = null;
  }
  /**
   * 配置方法，可重复调用，相同key配置新旧覆盖逻辑
   * @param cfg 配置数据JSON
   * @param cfg.appid 应用标识
   * @param cfg.attrs 自定义需要上报的数据
   */
  setConfig(cfg: HBConfig) {
    const { attrs, tid, appid, getUser, getBizData, requestFilter } = cfg;
    if (!this.config.tid && tid) {
      this.config.tid = tid;
    }
    if (!this.config.appid && appid) {
      this.config.appid = appid;
    }
    // if (!this.config.reportHost && reportHost) {
    //   this.config.reportHost = reportHost;
    // }
    if (getUser) {
      this.config.getUser = getUser;
    }
    if (getBizData) {
      this.config.getBizData = getBizData;
    }
    if (requestFilter) {
      this.config.requestFilter = requestFilter;
    }
    if (attrs) {
      Object.assign(this.config.attrs, attrs);
    }
  }
}

if(!win.uba) {
  // 向外暴露的对象
  win.uba = {
    ...sdkInfo,
    ymcHeaderDecode,
    getSid(shouldAutoCreate = false) {
      return shouldAutoCreate ? session.getCurrentSid() : session.getSid();
    },
  };
  const hubbleMonitor = new HubbleMonitor();
  Object.assign(win.uba, {
    isEnabled() {
      return hubbleMonitor.status === HB_STATUS.RUNNING;
    },
    getConfig() {
      return hubbleMonitor.config;
    },
    setConfig: (cfg: HBConfig) => {
      hubbleMonitor.setConfig(cfg);
    },
    setAttrs: (attrs: Record<string, unknown>) => {
      hubbleMonitor.setConfig({ attrs });
    },
    startBizOp: (ba: string, option?: {
      timeout?: number;
      btype?: string;
    }): ({ end: () => void }) => {
      return hubbleMonitor.startBizOp(ba, option);
    },
    endBizOp: (ba?: string) => {
      hubbleMonitor.endBizOp(ba);
    },
    report: (eventName: string, attrsData: Record<string, unknown>) => {
      hubbleMonitor.report(eventName, attrsData);
    },
    reportCountEvent: (ecid: string, ecbiz?: string) => {
      hubbleMonitor.reportCountEvent(ecid, ecbiz);
    },
    __instance: hubbleMonitor,
  });
  // 针对工作台环境，自动注入业务数据和用户数据获取逻辑
  if(isWorkbench()) {
    win.uba.setConfig({ getBizData, getUser: getUserInfo });
    hbLogger.info('workbench setConfig: getBizData, getUser');
  }
} else {
  hbLogger.warn(`当前环境已存在uba实例！`);
}

